<script>
  import Card from '../Card.svelte';
  import LaunchCardContent from './LaunchCardContent.svelte';
  import LaunchCardImageContent from './LaunchCardImageContent.svelte';

  /** @type {import('$lib/types/getAllLaunch.js').Launch} */
  export let launch;

  /** @type {string} */
  let cardUrl;

  /** @type {string} */
  let title;

  $: launch, loadLaunchDetails();

  function loadLaunchDetails() {
    cardUrl = `/tools/launch/${launch.id}`;
    title = launch.name ?? 'Unnamed Mission';
  }
</script>

<Card {cardUrl} {title}>
  <LaunchCardImageContent slot="card-image" {launch} />
  <LaunchCardContent slot="card-text" {launch} />
</Card>
